/** Sentinel value for “Other / Suggest a Category” in category dropdowns. */
export const CATEGORY_SUGGEST_VALUE = '__suggest_category__'

export function isCategorySuggestValue(value) {
  return value === CATEGORY_SUGGEST_VALUE
}

/**
 * Primary dropdown = top-level parent categories only.
 * @param {Array<{ value: number, text: string, parentId?: number|null }>} categories
 */
export function primaryCategoryOptions(categories = []) {
  const list = Array.isArray(categories) ? categories : []
  return list.filter(item => !item.parentId)
}

/**
 * Secondary dropdown = children of the selected primary only.
 * Empty until a primary is selected.
 * @param {Array<{ value: number, text: string, parentId?: number|null }>} categories
 * @param {number|null|undefined} primaryId
 */
export function secondaryCategoryOptions(categories = [], primaryId = null) {
  const pid = Number(primaryId || 0)
  if (!pid) return []

  const list = Array.isArray(categories) ? categories : []
  return list.filter(item => Number(item.parentId) === pid)
}
